var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Field, ObjectType } from "type-graphql";
import { Node } from "../relay.js";
import { DateTimeScalar } from "../scalars/DateTimeISO.js";
import { GlobalIdScalar } from "../scalars/GlobalId.js";
import { TimestampedResource } from "./Resource.js";
/*
The way configurations work is that there can be n number of configurations,
each with it's own UUID. When multiple configurations are created with the
same key, the most recent *VALID* configuration is used. This allows us to
create configurations in advance and have them automatically take effect
when the time comes.

This also means we have some of the logic we need for a configuration
to have additional validation logic in the future.
*/
let ConfigurationNode = class ConfigurationNode extends TimestampedResource {
    id;
    key;
    value;
    validAfter;
    validUntil;
    text() {
        return this.key;
    }
    getUniqueId() {
        return this.key;
    }
    static init(init) {
        return this.createInstance().withValues(init);
    }
};
__decorate([
    Field(() => GlobalIdScalar, { nullable: false }),
    __metadata("design:type", Object)
], ConfigurationNode.prototype, "id", void 0);
__decorate([
    Field(() => String, { nullable: false }),
    __metadata("design:type", String)
], ConfigurationNode.prototype, "key", void 0);
__decorate([
    Field(() => String, { nullable: false }),
    __metadata("design:type", String)
], ConfigurationNode.prototype, "value", void 0);
__decorate([
    Field(() => DateTimeScalar, { nullable: true }),
    __metadata("design:type", Object)
], ConfigurationNode.prototype, "validAfter", void 0);
__decorate([
    Field(() => DateTimeScalar, { nullable: true }),
    __metadata("design:type", Object)
], ConfigurationNode.prototype, "validUntil", void 0);
__decorate([
    Field(() => String, { nullable: false }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", String)
], ConfigurationNode.prototype, "text", null);
ConfigurationNode = __decorate([
    ObjectType({
        implements: [Node],
    })
], ConfigurationNode);
export { ConfigurationNode };
//# sourceMappingURL=Configuration.js.map